import SRP from './SRP';

export default SRP;
